import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-senha-expirada',
  templateUrl: './modal-senha-expirada.component.html',
  styleUrls: ['./modal-senha-expirada.component.scss']
})
export class ModalSenhaExpiradaComponent implements OnInit {

  @Input() tipoPesquisaVeiculo: String;
  @Input() formValues: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
}
